export type JournalTemplateScope = 'personal' | 'clinic';

export interface GroupableJournalTemplate {
  id: string;
  title: string;
  description?: string | null;
  content_md: string;
  scope?: string | null;
  created_by?: string | null;
  patient_id?: string | null;
}

export function partitionJournalTemplates<T extends GroupableJournalTemplate>(
  templates: T[],
): { personal: T[]; clinic: T[] } {
  const personal: T[] = [];
  const clinic: T[] = [];
  for (const template of templates) {
    if (template.scope === 'personal') personal.push(template);
    else clinic.push(template);
  }
  return { personal, clinic };
}

export function canManageJournalTemplate(
  template: Pick<GroupableJournalTemplate, 'scope'>,
  isAdmin: boolean,
): boolean {
  return isAdmin || template.scope === 'personal';
}

export function filterJournalTemplates<T extends GroupableJournalTemplate>(
  templates: T[],
  query: string,
): T[] {
  const needle = query.trim().toLowerCase();
  if (!needle) return templates;
  return templates.filter((template) => {
    const haystack = `${template.title} ${template.description ?? ''}`.toLowerCase();
    return haystack.includes(needle);
  });
}
